import axios from 'axios'
import Vue from 'vue'

const state = Vue.observable({
  commands: null,
  announcements: null,
  quotes: null,
  reactions: null,
  loading: false,
  error: null,
})

export default function useHelper() {
  async function fetchCommands() {
    state.loading = true
    state.error = null
    try {
      const r = await axios.get('/api/helper/commands')
      state.commands = r.data
    } catch (e) {
      state.error = e
    } finally {
      state.loading = false
    }
  }

  async function fetchAnnouncements() {
    state.loading = true
    state.error = null
    try {
      const r = await axios.get('/api/helper/announcements')
      state.announcements = r.data
    } catch (e) {
      state.error = e
    } finally {
      state.loading = false
    }
  }

  async function fetchQuotes() {
    state.loading = true
    state.error = null
    try {
      const r = await axios.get('/api/helper/quotes')
      state.quotes = r.data
    } catch (e) {
      state.error = e
    } finally {
      state.loading = false
    }
  }

  async function fetchReactions() {
    state.loading = true
    state.error = null
    try {
      const r = await axios.get('/api/helper/reactions')
      state.reactions = r.data
    } catch (e) {
      state.error = e
    } finally {
      state.loading = false
    }
  }

  return {
    state,
    fetchCommands,
    fetchAnnouncements,
    fetchQuotes,
    fetchReactions,
  }
}
